"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getValidationPassOrFail = (rule, validationsOnPass = [], validationsOnFail = []) => (fieldValue, formValues, props) => rule(formValues, props) ? validationsOnPass : validationsOnFail;
exports.default = getValidationPassOrFail;
